// import React from 'react'

// const ViewAwaitingInvoices = () => {
//   return (
//     <div>ViewAwaitingInvoices</div>
//   )
// }

// export default ViewAwaitingInvoices

import React, { useState } from "react";
import { dateFormator, mapTableRows } from "../../../../utils";
import {
  Button,
  CollapsibleSections,
  Divider,
  PageHeader,
  PageTitle,
} from "../../../../components";
import { useNavigate } from "react-router-dom";

const ViewAwaitingInvoices = () => {
  const navigate = useNavigate();
  const invoiceSectionsData = [
    {
      id: "lt-tech",
      title: "L&T Technologies Ltd",
      children: [
        {
          id: "mohammed",
          title: "Mohammed Karamat",
          children: [
            {
              id: "dev",
              title: "Dev",
              tableData: {
                rows: mapTableRows(
                  [
                    {
                      id: 1,
                      month: "2020-04-01",
                      totalHours: 24,
                      missingDates: "Apr 2020: 01, 02, 03",
                    },
                    {
                      id: 2,
                      month: "2020-05-01",
                      totalHours: 176,
                      missingDates:
                        "May 2020: 01, 02, 03, 04, 05, 06, 07, 08, 09, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31",
                    },
                  ],
                  [
                    {
                      key: "month",
                      label: "Month",
                      render: (row) =>
                        dateFormator(row.month, "shortMonthYear"),
                    },
                    {
                      key: "totalHours",
                      label: "Total Hours",
                      sortable: true,
                    },
                    {
                      key: "missingDates",
                      label: "Missing Dates",
                    },
                  ]
                ),
                columns: [
                  {
                    key: "month",
                    label: "Month",
                  },
                  {
                    key: "totalHours",
                    label: "Total Hours",
                    sortable: true,
                  },
                  {
                    key: "missingDates",
                    label: "Missing Dates",
                  },
                ],
              },
            },
          ],
        },
      ],
    },
  ];

  const timesheetSectionsData = [
    {
      id: "tekishub",
      title: "Tekishub",
      children: [
        {
          id: "sarah",
          title: "Sarah Johnson",
          children: [
            {
              id: "qa",
              title: "QA",
              tableData: {
                rows: mapTableRows(
                  [
                    {
                      id: 1,
                      weekEnding: "2023-04-28",
                      regular: 40,
                      overtime: 5,
                      status: "Submitted",
                    },
                    {
                      id: 2,
                      weekEnding: "2023-05-05",
                      regular: 35,
                      overtime: 0,
                      status: "Draft",
                    },
                  ],
                  [
                    {
                      key: "weekEnding",
                      label: "Week Ending",
                    },
                    {
                      key: "regular",
                      label: "Regular Hours",
                    },
                    {
                      key: "overtime",
                      label: "Overtime",
                    },
                    {
                      key: "status",
                      label: "Status",
                    },
                  ]
                ),
                columns: [
                  {
                    key: "weekEnding",
                    label: "Week Ending",
                  },
                  {
                    key: "regularHours",
                    label: "Regular Hours",
                  },
                  {
                    key: "overtime",
                    label: "Overtime",
                  },
                  {
                    key: "status",
                    label: "Status",
                  },
                ],
              },
            },
          ],
        },
      ],
    },
  ];

  return (
    <div className="border-[1px] border-neutrals-50 rounded px-4">
      <div className="mt-3">
        <PageHeader
          Section={
            <div className="flex">
              <PageTitle title={" Awaiting invoices"} tag="p" />
            </div>
          }
          RightSection={
            <Button
              type="icon"
              icon="close"
              variant="text"
              color="black"
              // onClick={() => {
              //   if (onBack) {
              //     onBack(); //
              //   } else {
              //     navigate("/invoices");
              //   }
              // }}
              onClick={() => navigate("/invoices")}
            />
          }
        />
        <Divider />
      </div>
      <CollapsibleSections sectionsData={invoiceSectionsData} />
      <CollapsibleSections sectionsData={timesheetSectionsData} />
      <CollapsibleSections sectionsData={invoiceSectionsData} />
      <CollapsibleSections sectionsData={timesheetSectionsData} />
    </div>
  );
};

export default ViewAwaitingInvoices;
